const KEY = "kp_progress";

export const readProgress = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "{}");
  } catch {
    return {};
  }
};

const keyOf = (animeId, season, number) => (Number(season) === 1 ? `${animeId}:${number}` : `${animeId}:s${season}:${number}`);

export const getEpisodeProgress = (animeId, number, season = 1) => readProgress()[keyOf(animeId, season, number)] || null;

export const saveProgress = (entry) => {
  const all = readProgress();
  all[keyOf(entry.animeId, entry.season || 1, entry.number)] = { season: 1, ...entry, updatedAt: Date.now() };
  localStorage.setItem(KEY, JSON.stringify(all));
};

export const clearProgress = (animeId, number, season = 1) => {
  const all = readProgress();
  delete all[keyOf(animeId, season, number)];
  localStorage.setItem(KEY, JSON.stringify(all));
};

export const continueList = () =>
  Object.values(readProgress())
    .filter((p) => p.duration > 0 && p.time > 5 && p.time / p.duration < 0.95)
    .sort((a, b) => b.updatedAt - a.updatedAt)
    .slice(0, 10);

export const watchPath = (animeId, number, season = 1) => `/watch/${animeId}/${number}${Number(season) !== 1 ? `?s=${season}` : ""}`;
